import { Injectable } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import {
  CREATE_UPDATE_CONFIG_DATA,
  GET_ACCESSLEVELS,
  GET_CATEGORY,
  GET_CONFIGURATION_VALUES,
  GET_USER_DETAILS_GUID,
  UPDATE_MASTER_CONFIG_DATA,
} from 'src/app/shared/constants/master-api-constants';
import { Observable } from 'rxjs';
import { GET_USER_ROLES } from 'src/app/shared/constants/user-api-constants';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  constructor(private apiService: ApiService) {}

  public getReportingCycleYear(): Observable<any> {
    return this.apiService.fetchData('master/getReportingCycleYear');
  }

  public getAccessLevels(): Observable<any> {
    return this.apiService.fetchData(GET_ACCESSLEVELS);
  }

  public getUserRoles(): Observable<any> {
    return this.apiService.fetchData(GET_USER_ROLES);
  }

  public getCategory(): Observable<any> {
    return this.apiService.fetchData(GET_CATEGORY);
  }

  public getUserDetailsByGUID(guid: string): Observable<any> {
    return this.apiService.fetchData(`${GET_USER_DETAILS_GUID}${guid}`);
  }

  public getConfigurationValues(): Observable<any> {
    return this.apiService.fetchData(`${GET_CONFIGURATION_VALUES}`);
  }

  public updateMasterConfigData(id, data): Observable<any> {
    return this.apiService.postData(`${UPDATE_MASTER_CONFIG_DATA}/${id}`, data);
  }

  public createUpdateConfigData(id, data): Observable<any> {
    return this.apiService.postData(`${CREATE_UPDATE_CONFIG_DATA}/${id}`, data);
  }
}
